import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Form';

const FormApi: any = baseApi(endpoint);

export default FormApi;